import React from "react";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";

/**
 * Displays section titles with consistent styling
 * @param {Object} props - Component props
 * @param {string} props.children - Title text
 * @returns {React.ReactElement} CardSubtitle component
 */
export const CardSubtitle = ({ children }) => (
  <Typography
    variant="span"
    component="div"
    sx={{
      color: "text.primary",
      fontFamily: 'var(--font-family-primary, "DM Sans")',
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "var(--font-spacing-regular, 0px)",
      "@media (max-width: 600px)": {
        fontSize: "14px",
        lineHeight: "20px"
      }
    }}
  >
    {children}
  </Typography>
);

CardSubtitle.propTypes = {
  children: PropTypes.node.isRequired
};
